import apiClient from './apiClient';

export const getBonusMalusData = async () => {
  const { data } = await apiClient.get(`/bonusMalus`);
  return data;
};

export const getBonusMalusStudentsData = async () => {
  const { data } = await apiClient.get(`/bonusMalus/students`);
  return data;
};

export const getBonusMalusTeachersData = async () => {
  const { data } = await apiClient.get(`/bonusMalus/teachers`);
  return data;
};

export const createBonusMalus = async bonusMalusObject => {
  return apiClient.post('/bonusMalus', bonusMalusObject);
};
